export default window.location.hostname === 'localhost'
  ? `http://localhost:${window.location.port}`
  : `https://osmosify.osmosis.org`;

export const osmosisHost = (port) =>
  window.location.hostname === 'localhost'
    ? `http://localhost:${port || window.location.port}`
    : `https://osmosis.org`;
